export default {
  APP_MODE: process.env.REACT_APP_ENVIRONMENT,
  BASE_URL: process.env.REACT_APP_API_BASE_URL
};
